// extracted by mini-css-extract-plugin
export default {"filled":"ScoreTag_filled__nW0v0"};